import React from "react";
import { DEALER } from "@/data/dealership";
import { useT } from "@/i18n/lang";
import { Award, Heart, MessageSquare } from "lucide-react";

export default function About() {
  const { t } = useT();
  return (
    <section id="about" data-testid="about-section" className="px-6 md:px-12 lg:px-16 py-20 md:py-32 bg-white">
      <div className="max-w-[1440px] mx-auto grid grid-cols-12 gap-8 items-center">
        <div className="col-span-12 lg:col-span-5">
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden bg-[#F8F8F9]">
              <img
                src={DEALER.headshot}
                alt={DEALER.consultant}
                className="w-full h-full object-cover object-top"
                data-testid="about-portrait"
                loading="eager"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 hidden md:block bg-[#EB0A1E] text-white px-6 py-4">
              <div className="font-display font-bold text-3xl leading-none">{t("about.years")}</div>
              <div className="text-xs uppercase tracking-[0.15em] mt-1">{t("about.yearsLabel")}</div>
            </div>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-7 lg:pl-8">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-8 h-px bg-[#EB0A1E]" />
            <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#EB0A1E]">
              {t("about.eyebrow")}
            </span>
          </div>
          <h2 className="font-display font-bold text-[#0A0A0A] text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
            {t("about.h1a")}<br />
            <span className="text-[#52525B]">{t("about.h1b")}</span>
          </h2>

          <p className="mt-6 text-[#52525B] text-base md:text-lg leading-relaxed max-w-2xl">
            {t("about.body")}
          </p>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
            <Value icon={<Heart className="w-5 h-5" />} title={t("about.value1Title")} body={t("about.value1Body")} />
            <Value icon={<MessageSquare className="w-5 h-5" />} title={t("about.value2Title")} body={t("about.value2Body")} />
            <Value icon={<Award className="w-5 h-5" />} title={t("about.value3Title")} body={t("about.value3Body")} />
          </div>
        </div>
      </div>
    </section>
  );
}

function Value({ icon, title, body }) {
  return (
    <div className="border-t border-[#0A0A0A] pt-5">
      <div className="text-[#EB0A1E] mb-3">{icon}</div>
      <div className="font-display font-semibold text-lg text-[#0A0A0A] tracking-tight">
        {title}
      </div>
      <p className="mt-2 text-sm text-[#52525B] leading-relaxed">{body}</p>
    </div>
  );
}
